





















































import { Http } from "fs-pb-vue2/services/api/http";
import { clientTime } from "fs-pb-vue2/utilities";
import { Component, Vue } from "vue-property-decorator";

@Component
export default class EbsStart extends Vue {
  loading: boolean = false;

  get isBrowserValid(): boolean {
    return navigator.userAgent.search(/MSIE/) > 0
      || navigator.userAgent.search(/NET CLR /) > 0
      || navigator.userAgent.search(/SputnikBrowser/) > 0
      || navigator.userAgent.search(/YaBrowser/) > 0;
  }

  async startEbs(): Promise<void> {
    this.loading = true;
    try {
    const resp = await Http.get(`EbsEsia/InitEsia?clientTime=${clientTime()}&source=0`);
    if (resp.result === 'ok') {
      this.loading = false;
      const linkAuth = resp.data.link;
      window.location.href = linkAuth;
    }
    else {
      this.$router.push(`/ebsesia?error=${resp.message}&error_descriptiom=${resp.message}`)
    }
  } catch(e) {
    this.$router.push(`/ebsesia?error=${e}&error_descriptiom=${e}`)
  }
  this.loading = false;
  }

  close(): void {
    this.$emit("hideEbsDialog")
  }
}
